import React from "react";

// Images
import topBannerImg from "../images/topBanner.jpeg";

function Header() {
  return (
    // <header className="m-b-30 sticky">
    <header className="m-b-30">
      <img className="full-width" src={topBannerImg} alt="top-banner" />
    </header>
  );
}

export default Header;
